<template>
  <VModal ref="modal" @close="$emit('close')">
    <template #default="modalProps">
      <div
        class="rounded shadow-xs w-full h-full mx-auto overflow-hidden"
        :class="[
          ['edit', 'preview'].indexOf(currentStep) >= 0 && 'max-w-7xl',
          currentStep === 'preview' && 'max-w-7xl',
          currentStep === 'send' && 'max-w-lg',
        ]"
      >
        <div class="rounded shadow-lg bg-white flex flex-col h-full">
          <div class="flex-none px-4 sm:px-6 py-5 border-b">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">
                  {{ dialogTitle }}
                </h1>
              </div>

              <div class="flex-none">
                <portal-target name="write-email-message-dialog-top-right-corner">
                  <button
                    type="button"
                    class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    @click="modalProps.close"
                  >
                    <span class="sr-only">Close</span>
                    <svg
                      class="inline-flex h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </portal-target>
              </div>
            </div>
          </div>
          <EditEmailMessage
            v-if="currentStep === 'edit'"
            :contact="contact"
            :contact-request="contactRequest"
            :email-message-id="internalMessageId"
            @saved="handleSaved"
            @preview="currentStep = 'preview'"
            @edit-template="currentStep = 'edit-template'"
          />
          <EditEmailTemplate
            v-else-if="currentStep === 'edit-template'"
            :email-message-id="internalMessageId"
            @edit="currentStep = 'edit'"
          />
          <Preview
            v-else-if="currentStep === 'preview'"
            :contact-id="contact.id"
            :email-message-id="internalMessageId"
            @edit="currentStep = 'edit'"
            @send="currentStep = 'send'"
          />
          <SendEmail
            v-else-if="currentStep === 'send'"
            :contact-id="contact.id"
            :email-message-id="internalMessageId"
            @sent="handleSent"
          />
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import EditEmailMessage from './EditEmailMessage.vue';
import EditEmailTemplate from './EditEmailTemplate.vue';
import Preview from './Preview.vue';
import SendEmail from './SendEmail.vue';

export default {
  name: 'WriteEmailMessageDialog',
  components: {
    EditEmailMessage,
    Preview,
    SendEmail,
    EditEmailTemplate,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
    contactRequest: {
      type: Object,
      default: () => null,
    },
    emailMessageId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentStep: 'edit',
      internalMessageId: this.emailMessageId,
    };
  },
  computed: {
    dialogTitle() {
      if (this.currentStep === 'edit') {
        return 'Write email';
      }

      if (this.currentStep === 'edit-template') {
        return 'Edit email template';
      }

      return this.currentStep === 'preview' ? 'Email preview' : 'Sending email...';
    },
  },
  methods: {
    handleSaved(emailMessage) {
      this.internalMessageId = emailMessage.id;
      this.$emit('saved');
    },
    handleSent() {
      this.$emit('sent');
      this.$refs.modal.close();
    },
  },
};
</script>
